import React from 'react';
import CardNav from './card-nav';

export function EsiteckCardNav({ scrollToSection }) {
  const items = [
    {
      label: "Services",
      bgColor: "#1e3a8a", // Blue
      textColor: "#fff",
      links: [
        { label: "Plomberie", ariaLabel: "Services de plomberie", sectionId: "services" },
        { label: "Chauffage", ariaLabel: "Services de chauffage", sectionId: "services" },
        { label: "Débouchage", ariaLabel: "Services de débouchage", sectionId: "services" },
        { label: "Serrurerie", ariaLabel: "Services de serrurerie", sectionId: "services" }
      ]
    },
    {
      label: "Avantages", 
      bgColor: "#f97316", // Orange
      textColor: "#fff",
      links: [
        { label: "Certifié & Assuré", ariaLabel: "Certification et assurance", sectionId: "avantages" },
        { label: "24h/24 - 7j/7", ariaLabel: "Disponibilité", sectionId: "avantages" },
        { label: "10+ ans d'expérience", ariaLabel: "Notre expérience", sectionId: "avantages" },
        { label: "Toute la Belgique", ariaLabel: "Zone d'intervention", sectionId: "zone-intervention" }
      ]
    },
    {
      label: "Contact",
      bgColor: "#374151", // Gray
      textColor: "#fff",
      links: [
        { label: "Devis Gratuit", ariaLabel: "Demander un devis", sectionId: "contact" },
        { label: "Témoignages", ariaLabel: "Avis clients", sectionId: "temoignages" },
        { label: "Processus", ariaLabel: "Notre processus", sectionId: "processus" },
        { label: "Urgence", ariaLabel: "Service d'urgence", sectionId: "contact" }
      ]
    }
  ];

  return (
    <CardNav
      logo="/SITECK.png"
      logoAlt="Esiteck - Plomberie & Chauffage"
      items={items}
      baseColor="#fff"
      menuColor="#1e3a8a"
      buttonBgColor="#1e3a8a"
      buttonTextColor="#fff"
      ease="power3.out"
      scrollToSection={scrollToSection}
    />
  );
}